var _mask, _g, _mask2, _g2, _mask3, _g3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSendmail = function SvgSendmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "sendmail_svg__a",
    width: 13,
    height: 17,
    x: 4,
    y: 2,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M4 2.78h12.616v15.775H4z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#sendmail_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF773D",
    fillRule: "evenodd",
    d: "M12.21 17.114c-2.32.05-6.376-1.802-7.648-5.102-1.47-3.807.054-7.606 3.264-8.843s6.888.554 8.356 4.361c1.213 3.145-.33 7.009-1.995 8.682l.77.589c.21.136.188.406-.111.734-.465.508-1.416.963-2.124 1.015-.209.015-.544.014-.66-.205-.06-.115-.012-.263.007-.384q.072-.424.14-.847",
    clipRule: "evenodd"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "sendmail_svg__b",
    width: 18,
    height: 13,
    x: 14,
    y: 21,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M14.97 21.456h16.957V33.89H14.97z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#sendmail_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    fillRule: "evenodd",
    d: "M31.927 23.05 30.86 33.892l-14.437-1.435a1.613 1.613 0 0 1-1.445-1.764l.906-9.236z",
    clipRule: "evenodd"
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "sendmail_svg__c",
    width: 17,
    height: 8,
    x: 15,
    y: 21,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M15.885 21.456h16.042v7.214H15.885z",
    clipRule: "evenodd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#sendmail_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    fillRule: "evenodd",
    d: "m15.885 21.456 16.042 1.595-8.66 5.619z",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4B4B4B",
    fillRule: "evenodd",
    d: "M24.793 19.578c-.56-1.298-1.732-2.316-2.901-2.531-1.14-.235-2.273.014-3.465.752-.2.124-.41.268-.628.417-1.108.766-1.897 1.233-2.722.792-.322-.172-.522-.622-.654-1.112-.421.295-.966.53-1.449.62.237.751.64 1.48 1.366 1.869 1.728.923 3.303-.164 4.346-.883.195-.135.383-.265.563-.376.839-.52 1.601-.7 2.344-.547.563.103 1.373.706 1.767 1.617.209.482.344 1.17.125 2.016l1.564.155c.202-.958.125-1.91-.256-2.79",
    clipRule: "evenodd"
  })));
};
export default SvgSendmail;